import { useMutation } from '@tanstack/react-query';

import { filesTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

export const uploadFiles: filesTypes.Upload = ({ files, entityId }) => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append('files', file);
  });

  if (entityId) {
    formData.append('entityId', entityId);
  }

  return axios.post(`/files/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

type UploadFilesOptions = {
  config?: MutationConfig<filesTypes.Upload>;
};

export function useUploadFiles({ config = {} }: UploadFilesOptions = {}) {
  return useMutation({
    ...config,
    mutationFn: uploadFiles,
  });
}
